import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import RootState from '../../modules/rootState';
import ClinicInformation, { StateFromProps, DispatchFromProps, OwnProps } from './ClinicInformation';
import * as providerData from 'src/modules/entities/provider';
import * as workflowData from 'src/modules/entities/workflow';
import * as clinicData from 'src/modules/entities/clinic';
import { ClinicInformationRequest } from 'src/models/clinic';
import Workflow from 'src/models/workflow';

const mapStateToProps = (rootState: RootState, props: OwnProps): StateFromProps => ({
    saving: clinicData.selectors.saving(rootState),
    saved: clinicData.selectors.saved(rootState),
    isPass: clinicData.selectors.isPass(rootState),

    facilities: providerData.selectors.getFacilities(rootState),
    loadingFacilities: providerData.selectors.getLoadingFacilities(rootState),

    registrationId: workflowData.selectors.getRegistrationId(rootState),
    userInfo: workflowData.selectors.getUserInfo(rootState),
    providerInformation : providerData.selectors.getProviderInformationPayment(rootState),
    
    workflow: workflowData.selectors.getWorkflow(rootState),
    checkRetry: workflowData.selectors.checkRetry(rootState)
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
    getFacilitiesByTenantNameAsync: (tenantName: string): void => {
            dispatch(providerData.actions.getFacilitiesByTenantNameAsync(tenantName));
        },
    addClinicInformation: (clinicInformation: ClinicInformationRequest) : void => {
        dispatch(clinicData.actions.addClinicInformationAsync(clinicInformation));
    },
    updateWorkflow: (workflow: Workflow): void => {
        dispatch(workflowData.actions.storeWorkflowData(workflow));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ClinicInformation);


// WEBPACK FOOTER //
// ./src/components/ClinicInformation/ClinicInformation.container.ts